// SPDX-License-Identifier: AGPL-3.0-or-later

import {Locales} from '@fluxer/constants/src/Locales';

export const DEFAULT_NUMBER_LOCALE = Locales.EN_US;
